















































































































































import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import CarDetail from '@/components/CarDetail.vue';
import OrderService from '@/services/order.service';
import SignalRService from '@/services/signalr.service';
import { getModule } from 'vuex-module-decorators';
import BaseServiceMixin from '@/mixins/base.service.mixin';
import OrderDetailModel from '@/models/OrderDetailModel';
import Shared from '@/common/shared';
import eventBus from '@/common/bus';
import { OrderFilter } from '@/common/enum';
import StoreVuexModule from '@/stores/StoreVuexModule';

@Component({
  name: 'OrderList',
  components: {
    CarDetail,
  },
  filters: {
    formatDate: Shared.formatDate,
  },
})
export default class OrderList extends Mixins(BaseServiceMixin) {
  private orderService!: OrderService;
  private orderSignalR!: SignalRService;
  private store = getModule(StoreVuexModule, this.$store);

  private rowsPerPage: number = 5;
  private offset: number = 0;
  private totalRecords: number = 0;

  private search: string = '';
  private isOrdered: number = OrderFilter.Pending;

  private loading: boolean = false;
  private orders: OrderDetailModel[] = [];
  private newOrders: OrderDetailModel[] = [];

  private selectOrderItems: any = [
    { label: 'Pending', value: OrderFilter.Pending },
    { label: 'Ordered', value: OrderFilter.Ordered },
    { label: 'All', value: OrderFilter.All },
  ];
  private OrderHeader: any = [
    {
      text: '',
      align: 'left',
      sortable: false,
      value: 'model',
      class: 'primary--text',
    },
    {
      text: 'Id',
      align: 'left',
      sortable: false,
      value: 'id',
      class: 'primary--text',
    },
    {
      text: 'Reg No',
      value: 'regNo',
      class: 'primary--text',
      sortable: false,
      align: 'left',
    },
    {
      text: 'Date and Time',
      value: 'dateTime',
      class: 'primary--text',
      sortable: false,
      align: 'left',
    },
    {
      text: 'Make',
      value: 'make',
      class: 'primary--text',
      sortable: false,
      align: 'left',
    },
    {
      text: 'Model',
      value: 'model',
      class: 'primary--text',
      sortable: false,
      align: 'left',
    },
    {
      text: 'Is Ordered?',
      value: 'modal',
      class: 'primary--text',
      sortable: false,
      align: 'left',
    },
  ];

  public async created() {
    this.orderService = new OrderService(this.axiosInstance);
    this.orderSignalR = new SignalRService(this.axiosInstance, 'orders');
    this.orderSignalR.addHandler('order-message', this.onOrderMessage);
  }

  private mounted() {
    this.store.setRequiredUserRole('OrderPoint');
    this.loadData();
  }

  private async destroyed() {
    try {
      await this.orderSignalR.disconnectHub();
    } catch (err) {
      // handle error
    }
  }

  private get storeId(): number {
    return this.store.user.storeId;
  }

  private get authorized(): boolean {
    return this.store.hasRequiredUserRole;
  }

  @Watch('authorized')
  @Watch('storeId')
  private async loadData() {
    if (this.authorized && !this.loading) {
      this.getOrders();
      try {
        await this.orderSignalR.connectHub();
      } catch (err) {
        // handle error
      }
    }
  }

  private async onOrderMessage(data: any) {
    if (
      this.isOrdered === OrderFilter.All ||
      this.isOrdered === OrderFilter.Pending
    ) {
      try {
        const order = await this.orderService.GetOrderById(data.orderId);
        if (order) {
          if (!this.search) {
            this.pushNewOrder(order);
            return;
          }
          if (order.regNo && order.regNo.includes(this.search)) {
            this.pushNewOrder(order);
          }
        }
      } catch (err) {
        // handle error
      }
    }
  }

  private get showLoadMore() {
    return this.orders.length < this.totalRecords;
  }

  private async getOrders() {
    try {
      this.loading = true;
      const filters: any = {
        size: this.rowsPerPage,
        keyword: this.search,
        isOrdered: this.isOrdered,
        offset: this.orders.length,
      };

      const data = await this.orderService.List(filters);
      this.orders.push.apply(this.orders, data.items);
      this.totalRecords = data.count;
    } catch (error) {
      // error
    } finally {
      this.loading = false;
    }
  }

  private filterOrders() {
    this.orders = [];
    this.totalRecords = 0;
    this.getOrders();
  }

  private toVehicleDetails(item: OrderDetailModel) {
    const odm = new OrderDetailModel();
    Object.assign(odm, item);
    return odm.toVehicleDetail;
  }

  private toSelectedAttributes(item: OrderDetailModel) {
    const odm = new OrderDetailModel();
    Object.assign(odm, item);
    return odm.toSelectedAttributeModel;
  }

  private async onChange(index: number) {
    this.loading = true;
    const status: boolean = !this.orders[index].isOrdered;
    this.orders[index].isOrdered = status;

    let id: number | undefined = 0;
    id = this.orders[index].id;

    try {
      if (id) {
        const result = await this.orderService.changeStatus(id, status);
        if (result) {
          this.orders[index] = result;
          if (status && this.isOrdered === OrderFilter.Pending) {
            this.orders = this.orders.filter((o) => o.id !== result.id);
          }
        } else {
          eventBus.$emit(
            'errorHandler',
            Shared.messages.UNABLE_TO_CHANGE_STATUS,
            true,
          );
          this.orders[index].isOrdered = !status;
        }
      } else {
        this.orders[index].isOrdered = !status;
      }
    } catch (err) {
      // handle err
    } finally {
      this.loading = false;
    }
  }

  private isNew(order: OrderDetailModel) {
    return this.newOrders.includes(order);
  }

  private pushNewOrder(order: OrderDetailModel) {
    // append on the top of the list
    this.orders.unshift.apply(this.orders, [order]);
    // save in newOrders array
    this.newOrders.push(order);

    setTimeout(() => {
      this.newOrders = this.newOrders.filter((o) => o.id !== order.id);
    }, 15 * 60 * 1000);
  }

  private loadMore() {
    this.getOrders();
  }
}
